import React from 'react';
import splashBg from '../../assets/splash_bg.png';
import pkg from '../../../package.json';
const { version } = pkg;

const Landing = () => (
  <div style={containerStyle}>
    <div style={overlayStyle}>
      <h1 style={titleStyle}>Panel de Administración</h1>
      <span style={versionStyle}>v{version}</span>
    </div>
  </div>
);

const containerStyle = {
  height: '100vh',
  width: '100%',
  backgroundImage: `url(${splashBg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const overlayStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.50)',
  borderRadius: '12px',
  padding: '40px 60px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
};

const titleStyle = {
  color: '#FFFFFF',
  fontSize: '2.4rem',
  fontWeight: '700',
  margin: 0,
  letterSpacing: '0.5px',
};

const versionStyle = {
  color: '#C73B33',
  fontSize: '1rem',
  fontWeight: '500',
  letterSpacing: '1px',
};

export default Landing;
